import SimpleModal from "../../../components/SimpleModal";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { createStudent } from "../studentSlice";

export const StudentCreateModal = ({ setIsStudentModalOpen }) => {
  const dispatch = useDispatch();

  const [studentData, setStudentData] = useState({
    name: "",
    grade: "",
    student_phone: "",
    parent_phone: "",
  });

  const handleStudentSubmit = async () => {
    const gradeMapping = {
      초1: 1,
      초2: 2,
      초3: 3,
      초4: 4,
      초5: 5,
      초6: 6,
      중1: 7,
      중2: 8,
      중3: 9,
      고1: 10,
      고2: 11,
      고3: 12,
    };

    if (
      !studentData.name.trim() ||
      !studentData.grade ||
      !studentData.student_phone.trim() ||
      !studentData.parent_phone.trim()
    ) {
      alert("모든 입력값을 채워주세요.");
      return;
    }

    try {
      await dispatch(
        createStudent({
          ...studentData,
          grade: gradeMapping[studentData.grade],
        })
      ).unwrap();

      alert("학생이 등록되었습니다.");
      setIsStudentModalOpen(false);
    } catch (err) {
      alert(err.error);
    }
  };

  return (
    <SimpleModal
      title="학생 추가하기"
      onClose={() => setIsStudentModalOpen(false)}
      onSubmit={handleStudentSubmit}
      buttonText="추가하기"
    >
      <div
        style={{
          fontSize: "16px",
          marginBottom: "8px",
        }}
      >
        학년
      </div>
      <div style={{ paddingBottom: "20px" }}>
        <select
          style={{
            padding: "8px",
            borderRadius: "5px",
            border: "1px solid #2D2D2D",
            width: "396px",
          }}
          value={studentData.grade}
          onChange={(e) =>
            setStudentData({ ...studentData, grade: e.target.value })
          }
        >
          <option value="">학년을 선택하세요</option>
          {[
            "초1",
            "초2",
            "초3",
            "초4",
            "초5",
            "초6",
            "중1",
            "중2",
            "중3",
            "고1",
            "고2",
            "고3",
          ].map((grade) => (
            <option key={grade} value={grade}>
              {grade}
            </option>
          ))}
        </select>
      </div>
      <div
        style={{
          fontSize: "16px",
          marginBottom: "8px",
        }}
      >
        이름
      </div>
      <div style={{ paddingBottom: "20px" }}>
        <input
          type="text"
          placeholder="이름을 입력하세요."
          value={studentData.name}
          style={{
            padding: "8px 12px",
            borderRadius: "5px",
            border: "1px solid #2D2D2D",
            width: "370px",
          }}
          onChange={(e) =>
            setStudentData({ ...studentData, name: e.target.value })
          }
        />
      </div>
      <div
        style={{
          fontSize: "16px",
          marginBottom: "8px",
        }}
      >
        학생 전화번호
      </div>
      <div style={{ paddingBottom: "20px" }}>
        <input
          type="text"
          placeholder="학생 전화번호를 입력하세요."
          value={studentData.student_phone}
          style={{
            padding: "8px 12px",
            borderRadius: "5px",
            border: "1px solid #2D2D2D",
            width: "370px",
          }}
          onChange={(e) =>
            setStudentData({ ...studentData, student_phone: e.target.value })
          }
        />
      </div>
      <div
        style={{
          fontSize: "16px",
          marginBottom: "8px",
        }}
      >
        부모 전화번호
      </div>
      <div style={{ paddingBottom: "20px" }}>
        <input
          type="text"
          placeholder="부모 전화번호를 입력하세요."
          value={studentData.parent_phone}
          style={{
            padding: "8px 12px",
            borderRadius: "5px",
            border: "1px solid #2D2D2D",
            width: "370px",
          }}
          onChange={(e) =>
            setStudentData({ ...studentData, parent_phone: e.target.value })
          }
        />
      </div>
    </SimpleModal>
  );
};

export default StudentCreateModal;
